import { Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikDatePicker from "../../../commons/formik/FormikDatePicker";
import FormikTextField from "../../../commons/formik/FormikTextField";
import RequeridoLabel from "../../../commons/labels/RequeridoLabel";
import { StyledNuevaObra } from "../../../styled/Obras";
import FechaPresentacionObra from "../commons/FechaPresentacionObra";
import TitleWithUnderline from "../commons/TitleWithUnderline";
import useGestionObra from "../hooks/useGestionObra";
import { demolitionFormValidation } from "../validation/formValidation";
import CharactersCounterLabel from "../../../commons/labels/CharactersCounterLabel";

const DemolicionForm = ({ initialValues, formModel, handleSubmit, lastFormProps, }) => {
  const itemsActividades = useSelector((state) => state.obra.postNuevaObra.actividad.preguntas[0].itemsFormularioArt)
  const habilitarEdicionObra = useSelector(
    (state) => state.obra.habilitarEdicionObra.data
  );
  const [nombreGestionObra] = useGestionObra(lastFormProps?.tipoAvisoObra, lastFormProps?.estado, lastFormProps?.informadoSRT, habilitarEdicionObra);
  return (
    <Formik
      initialValues={formModel}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={() => demolitionFormValidation(nombreGestionObra, itemsActividades)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FechaPresentacionObra />
            </Grid>

            <TitleWithUnderline title="RESOLUCIÓN 550/11" />

            <StyledNuevaObra.GridContainer container>
              <Grid item xs={6}>
                <Typography variant="subtitle1">
                  Demoliciones de edificios mayores a 3 metros
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <FormikDatePicker
                  name="demolicion.fechaInicioDemolicion"
                  label="Fecha Inicio"
                  callback={(value) => {
                    if (value === null) {
                      setFieldValue("demolicion.fechaFinDemolicion", null);
                    }
                  }}
                />
              </Grid>

              <Grid item xs={3}>
                <FormikDatePicker
                  name="demolicion.fechaFinDemolicion"
                  label="Fecha Fin"
                  disabled={!values.demolicion.fechaInicioDemolicion}
                />
              </Grid>
            </StyledNuevaObra.GridContainer>

            <StyledNuevaObra.GridContainer container>
              <Grid item xs={6}>
                <Typography variant="subtitle1">
                  Excavaciones de subsuelos y/o submuraciones
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <FormikDatePicker
                  name="demolicion.fechaInicioExcavacion"
                  label="Fecha Inicio"
                  callback={(value) => {
                    if (value === null) {
                      setFieldValue("demolicion.fechaFinExcavacion", null);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <FormikDatePicker
                  name="demolicion.fechaFinExcavacion"
                  label="Fecha Fin"
                  disabled={!values.demolicion.fechaInicioExcavacion}
                />
              </Grid>
              
            </StyledNuevaObra.GridContainer>

            <TitleWithUnderline title="EXCAVACIONES A CIELO ABIERTO MAYORES A 1.2 mts" />

            <StyledNuevaObra.GridContainer container>
              <Grid item xs={6}>
                <Typography variant="subtitle1">
                  Excavaciones a cielo abierto
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <FormikDatePicker
                  name="demolicion.fechaInicioExcavacionCA"
                  label="Fecha Inicio"
                  callback={(value) => {
                    if (value === null) {
                      setFieldValue("demolicion.fechaFinExcavacionCA", null);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <FormikDatePicker
                  name="demolicion.fechaFinExcavacionCA"
                  label="Fecha Fin"
                  disabled={!values.demolicion.fechaInicioExcavacionCA}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }} >
                <FormikTextField
                  name="demolicion.excavacionCAOtros"
                  label="Detalle de la excavación"
                  variant="outlined"
                  fullWidth
                  multiline
                  maxRows={2}
                  minRows={2}
                />
                <CharactersCounterLabel
                  value={values.demolicion.excavacionCAOtros}
                  maxCharacters={100}
                />
              </Grid>
            </StyledNuevaObra.GridContainer>
            <TitleWithUnderline title="Observaciones - Otros Detalles" />
            <StyledNuevaObra.GridContainer container>
              <Grid item xs={12}>
                <FormikTextField
                    name="demolicion.observaciones"
                    label="Observación de Obra"
                    variant="outlined"
                    fullWidth
                    multiline
                    maxRows={15}
                    minRows={2}
                  />
                  <CharactersCounterLabel
                    value={values.demolicion.observaciones}
                    maxCharacters={2000}
                  />
              </Grid>
            </StyledNuevaObra.GridContainer>
          </Grid>
          
          <StyledNuevaObra.ButtonContainer>
            <FormikActions submit="Siguiente" />
          </StyledNuevaObra.ButtonContainer>
        </Form>
      )}
    </Formik>
  );
}

export default DemolicionForm;
